export const ItemListSchema = (itemListElement) => {
  const schema = {
    ["@context"]: "https://schema.org",
    ["@type"]: "ItemList",
    itemListElement,
  };
  return schema;
};
